import { Typography } from "@mui/material";

import AliasChannelHeader from "@/components/AliasChannelHeader.tsx";
import FeedHeader from "@/components/FeedHeader.tsx";
import Locator from "@/locator.ts";

type CombinedHeaderContentProps = {
  type: "non-feed" | "alias-channel" | "feed";
  aliasChannel?: { alias: string; title: string; name: string; id: string };
  activeNonFeedPageLabel?: string;
};

export default function CombinedHeaderContent({
  type,
  aliasChannel,
  activeNonFeedPageLabel,
}: CombinedHeaderContentProps) {
  return (
    <>
      {type === "non-feed" && activeNonFeedPageLabel && (
        <Typography
          aria-label={Locator.mainNav.displayTitle}
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 700,
            width: "100%",
          }}
          noWrap
        >
          {activeNonFeedPageLabel}
        </Typography>
      )}
      {type === "alias-channel" && aliasChannel && <AliasChannelHeader aliasChannel={aliasChannel} />}
      {type === "feed" && <FeedHeader />}
    </>
  );
}
